import { render, staticRenderFns } from "./ShareGroupModal.vue?vue&type=template&id=e55051a6&scoped=true"
import script from "./ShareGroupModal.vue?vue&type=script&lang=js"
export * from "./ShareGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55051a6",
  null
  
)

export default component.exports